export default __webpack_public_path__ + "static/media/Wappen-NTSV-4c-Blende.afea950a.svg";